export function headerFunc() {
  let windowWidth = window.innerWidth;
  const headerLogo = document.querySelector('.site-header-logo img');
  const path = document.querySelector('body').dataset.stylesheetDir;

  // if (windowWidth < 992) {
  //   headerLogo.src = path + '/img/common/logo_sp.svg';
  // } else {
  //   headerLogo.src = path + '/img/common/logo_pc.svg';
  // }

  // window.addEventListener('resize', function () {
  //   windowWidth = window.innerWidth;

  //   if (windowWidth < 992) {
  //     headerLogo.src = path + '/img/common/logo_sp.svg';
  //   } else {
  //     headerLogo.src = path + '/img/common/logo_pc.svg';
  //   }
  // });

  /**
   * パンくずリストのカスタマイズ
   */
  const breadcrumbItems = document.querySelectorAll('.breadcrumb-list__item');
  const homeUrl = document.querySelector('body').dataset.homeUrl;
  if (breadcrumbItems.length > 0) {
    breadcrumbItems.forEach((item) => {
      const child = item.querySelector('a, span');
      if (child.innerText === '施工事例') {
        // aタグへ変更
        const aTag = document.createElement('a');
        aTag.setAttribute('href', homeUrl + 'works');
        aTag.innerText = '施工事例';
        item.innerHTML = '';
        item.appendChild(aTag);
      } else if (child.innerText === 'コラム') {
        // aタグへ変更
        const aTag = document.createElement('a');
        aTag.setAttribute('href', homeUrl + 'column');
        aTag.innerText = 'コラム';
        item.innerHTML = '';
        item.appendChild(aTag);
      }

      // hrefに「/works/category/」を含む場合
      const href = child.getAttribute('href');
      if (href !== null) {
        if (href.includes('/works/category/')) {
          const termId = document.querySelector('body').dataset.termId;
          child.setAttribute('href', homeUrl + 'works/' + '?term=' + termId);
          const text = child.innerText;
          const textEn = document.querySelector('body').dataset.termEn;
          child.innerText = `${textEn}（${text}）`;
        } else if (href.includes('/column/category/')) {
          const termId = document.querySelector('body').dataset.termId;
          child.setAttribute('href', homeUrl + 'column/' + '?term=' + termId);
          const text = child.innerText;
          const textEn = document.querySelector('body').dataset.termEn;
          child.innerText = `${textEn}（${text}）`;
        }
      }
    });
  }
}
